<template>
    <Paper class="tenant-relations">
        <div class="tenant-relations-head">
            <el-row>
                <el-col :span="21">
                    <el-row>
                        <el-col class="tenant-relations-head-item">
                            <el-input v-model="searchData.tenantNumber" :placeholder="$translate('lang.E320212342342342423403170007', { defaultText: '租户编码' })"></el-input>
                        </el-col>
                        <el-col class="tenant-relations-head-item">
                            <el-select v-model="searchData.tableFlag" :placeholder="$translate('lang.E3202110110004', { defaultText: '数据表' })" clearable >
                                <el-option v-for="(item,index) in tableFlagList" :value="item.code" :key="index" :label="item.name"> </el-option>
                            </el-select>
                        </el-col>
                        <div>
                            <el-button type="primary" size="mini" :loading="searchloading" @click="searchChange" icon='el-icon-search'>
                            {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                            </el-button>
                            <el-button size="mini" @click="restSearchChange" class="sn-search-reset-button">
                                {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                            </el-button>
                        </div>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <m-plane
            ref="mPlane"
            :config="config"
            :pageTotal="pageTotal"
            :tableData="tableData"
            @btn-event="btnEvent"
            @onSearchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="page-module-btn">
                <el-button type="primary" size="mini" icon="el-icon-plus" @click="addBtn">
                    {{$translate('lang.E3202102260005', { defaultText: '新增' })}}
                </el-button>
            </div>
        </m-plane>
        <!-- 新增修改弹窗 -->
        <system-module
            ref="systemModule"
            :ruleForm="ruleForm"
            :saveLoading="saveLoading"
            :verification="verification"
            :dialogVisible="dialogVisible"
            :initTableColumns="initTableColumns"
            @closeEdit="closeEdit"
            @saveData="saveDate"
        ></system-module>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import mPlane from '../../../components/IdentityComponent/Main.vue';
import systemModule from '../../../components/basicDataDialog/editDetail/editDetail';
import { config } from './config';
import { dictWithUrl } from '../../../components/basicDataDialog/api.js';
import { tenantRelSearch, tenantRelAdd, tenantRelEdit, tenantRelDetail } from '../../../api/systemManagementApi';
export default {
    name: 'tenantRelations',
    components: { Paper, mPlane, systemModule },
    data() {
        return {
            config: config,
            ruleForm: {},
            searchData: {},
            tableData: [],
            dictOptions: {},
            tableFlagList: [],
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            searchloading: false,
            saveLoading: false,
            dialogVisible: false,
            initTableColumns: config.table.dialogColumns,
            verification: {
                tableFlag: [{ required: true, message: this.$translate('lang.E3202110110006', { defaultText: '表名不能为空' }), trigger: 'blur' }]
            }
        };
    },
    methods: {
        restSearchChange() { // 重置
            this.searchData = {};
        },
        searchChange() {
            this.$refs.mPlane.$refs.page.pageState = false;
            this.pageNo = 1;
            this.config.page.pageSize = 1;
            this.searchloading = true;
            this.loadData();
            this.$nextTick(() => {
                this.$refs.mPlane.$refs.page.pageState = true;
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        closeEdit() {
            this.dialogVisible = false;
        },
        openEdit() {
            this.dialogVisible = true;
        },
        saveDate(data) {
            const params = data;
            if (!params.tenantNumber && !params.sourceSys) {
                this.$message.warning(this.$translate('lang.E3202110110007', { defaultText: '租户编码、来源系统不能同时为空！' }));
                return;
            }
            if (params.tenantNumber && params.sourceSys) {
                this.$message.warning(this.$translate('lang.E3202112160002', { defaultText: '租户编码、来源系统不能同时配置！' }));
                return;
            }
            if (params.id) {
                this.updateInfo(params);
            } else {
                this.saveInfo(params);
            }
        },
        updateInfo(params) {
            this.saveLoading = true;
            tenantRelEdit(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(this.$translate('lang.EXC202102260002', { defaultText: '更改成功' }));
                    this.loadData();
                    this.closeEdit();
                }
            }).finally(() => {
                this.saveLoading = false;
            });
        },
        saveInfo(params) {
            this.saveLoading = true;
            tenantRelAdd(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(this.$translate('lang.E3202103190009', { defaultText: '新增成功' }));
                    this.loadData();
                    this.closeEdit();
                }
            }).finally(() => {
                this.saveLoading = false;
            });
        },
        btnEvent(rowData, event) {
            switch (event) {
            case 'edit':
                this.editBtn(rowData);
                break;
            case 'delete':
                this.deleteBtn(rowData);
                break;
            default:
                break;
            }
        },
        addBtn() {
            this.ruleForm = {};
            this.openEdit();
        },
        editBtn(row) {
            this.ruleForm = JSON.parse(JSON.stringify(row));
            this.openEdit();
        },
        deleteBtn(row) {
            if (!row || !row.id) { return; }
            this.$confirm(this.$translate('lang.EXC202002220007', { defaultText: '此操作将删除选中数据, 是否继续' }),
                this.$translate('lang.E3202102220028', { defaultText: '提示' }), {
                    confirmButtonText: this.$translate('lang.E3202101270001', { defaultText: '确定' }),
                    cancelButtonText: this.$translate('lang.E3202101270002', { defaultText: '取消' })
                }).then(() => {
                tenantRelDetail(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(this.$translate('lang.EXC202102230001', { defaultText: '删除成功！' }));
                        this.loadData();
                    }
                });
            });
        },
        async dictData(data) { // 获取表格、搜索条件转换所需数据字典
            const dictuRL = '/api-sn/config/tenantSourcesysTable/getDictList';
            const options = await dictWithUrl('SOURCE_SYS,TABLE_FLAG', dictuRL);// SOURCE_SYS-来源系统,TABLE_FLAG-数据表
            this.dictOptions = {};
            this.tableFlagList = [];
            if (+options.code === 0) {
                this.tableFlagList = options.data.TABLE_FLAG;// 下拉框配置
                for (const key in options.data) {
                    if (options.data.hasOwnProperty(key)) {
                        this.dictOptions[key] = {};
                        options.data[key].forEach(item => {
                            this.dictOptions[key][item.code] = item.name;
                        });
                    }
                }
            }
        },
        async loadData() {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.searchData
            };
            tenantRelSearch(params).then(res => {
                if (res && +res.code === 0) {
                    res.data.list.forEach(item => {
                        item.tenantNumberTxt = item.tenantNumber || '--';
                        item.tableFlagTxt = this.dictOptions.TABLE_FLAG[item.tableFlag] || '--';
                        item.sourceSysTxt = this.dictOptions.SOURCE_SYS[item.sourceSys] || '--';
                    });
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.searchloading = false;
            });
        }
    },
    async created() {
        await this.dictData();
        this.searchChange();
    }
};
</script>
<style lang="less">
.tenant-relations{
    .tenant-relations-head {
        margin-bottom: 20px;
    }
    .tenant-relations-head-item {
        width: 190px;
        margin-right: 10px;
        .el-select{
            width: 100%;
        }

    }
    .nPanel .row-bg {
        margin-top: 20px;
    }
    .nPanel .el-table {
        height: calc(100vh - 180px) !important;
    }
}
</style>